module.exports = __webpack_public_path__ + "static/media/解放骄阳.61cb97c7.jpg";